import { Link } from 'ia-react-core';
import React, { FC } from 'react';
import { Attachment } from '../../../../../../../interfaces/Attachment';
import getPublicApiRoot from '../../../../../../../utils/getPublicApiRoot';
import { StyledAttachmentIcon, StyledDownloadIconWrapper, StyledLink, StyledListItem } from './AttachmentLink.styles';

export interface AttachmentLinkProps {
  attachment: Attachment;
}

const AttachmentLink: FC<AttachmentLinkProps> = ({ attachment }) => {
  const attachmentPath = `${getPublicApiRoot()}/content/secure?fileToken=${attachment.fileToken}`;

  return (
    <StyledListItem key={attachment.id}>
      <StyledLink>
        <Link data-testId="download" tabIndex={0} href={attachmentPath} target="_blank">{attachment.fileName}<StyledDownloadIconWrapper><StyledAttachmentIcon /></StyledDownloadIconWrapper></Link>
      </StyledLink>
    </StyledListItem>
  );
};
export default AttachmentLink;
